(function () {
    'use strict';

    angular
        .module('app.core')
        .controller('LogoutController', LogoutController);

    LogoutController.$inject = ['$window', 'userService', 'logger', 'backendHubProxy'];
    /* @ngInject */
    function LogoutController($window, userService, logger, backendHubProxy) {
        var vm = this;
        vm.title = 'Logout';
        vm.message = "You've successfully logged out";
        activate();

        function activate() {
            backendHubProxy.stop();
            logger.info('Activated ' + vm.title + ' View');
            logout();
        }

        function logout() {
            userService.logout();
        }
    }
})();
